import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // scrollBehavior() {   //切换路由滚动条会置顶
  //   return { x: 0, y: 0 }
  // },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      // meta: {
      //   pageTitle: 'Home',
      //   breadcrumb: [
      //     {
      //       text: 'Home',
      //       active: true,
      //     },
      //   ],
      // },
    },
    {
      path: "/App",
      name: "App",
      component: () => import("@/views/open/App.vue"),
    },
    {
      path: "/Business",
      name: "Business",
      component: () => import("@/views/business/List.vue"),
    },
    {
      path: "/Business/:id?/Edit",
      name: "BusinessEdit",
      component: () => import("@/views/business/Edit.vue"),
      meta: {
        navActiveLink: "Business",
      },
    },
	 {
      path: "/Company",
      name: "Company",
      component: () => import("@/views/company/List.vue"),
    },
    {
      path: "/CompanyUser",
      name: "CompanyUser",
      component: () => import("@/views/company/UserList.vue"),
    },
    {
      path: "/App/:id?/AppEdit",
      name: "AppEdit",
      component: () => import("@/views/open/AppEdit.vue"),
      meta: {
        navActiveLink: "App",
      },
    },
    {
      path: "/App/:id?/AppScope",
      name: "AppScope",
      component: () => import("@/views/open/AppScope.vue"),
      meta: {
        navActiveLink: "App",
      },
    },
    {
      path: "/Open/Authorize",
      name: "Authorize",
      component: () => import("@/views/open/Authorize.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/Open/SchemeLaunch",
      name: "SchemeLaunch",
      component: () => import("@/views/open/SchemeLaunch.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/Login",
      name: "Login",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/AuthCallback",
      name: "AuthCallback",
      component: () => import("@/views/AuthCallback.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/Register",
      name: "Register",
      component: () => import("@/views/Register.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
